import { updateField } from "vuex-map-fields";

export default {
  updateField,
  setState(state, payload) {
    state[payload.name] = payload.value;
  },
  setStateProperty(state, payload) {
    state[payload.state][payload.property] = payload.value;
  }
};
